<ngx-spinner [name]="'relatorio-promocoes-clientes'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Relatório promoções-clientes</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Promoção</mat-label>
                    <mat-select [(ngModel)]="sBuscaRelatorio">
                        <mat-option *ngFor="let tipo of aGruposPromocionais" [value]="tipo">
                            {{tipo.Nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-auto">
                <button class="mt-4" mat-flat-button color="primary" (click)="gerarRelatorio()">
                    <mat-icon>search</mat-icon> Gerar relatório
                </button>
            </div>
        </div>

        <div class="row" *ngIf="sBuscaRelatorio">
            <div class="col-auto">
                <div class="borda">
                    <div style="margin: 16px;">
                        <div class="titulo">Descrição</div>
                        <div>
                            <div class="preContador">Status:</div>
                            {{sBuscaRelatorio.Status ? 'Ativo' : 'Desativado'}}
                        </div>
                        <div>
                            <div class="preContador">Quantidade mínima:</div> {{sBuscaRelatorio.QuantidadeMinima}}
                        </div>
                        <div>
                            <div class="preContador">Produtos:</div> {{sBuscaRelatorio.NomeProdutos}}
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row mt-2" *ngIf="bExportar && sIDAntigo === sBuscaRelatorio.ID">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <div class="row mt-2">

                    <div class="col-auto">
                        <button mat-flat-button color="primary" (click)="alterarSobDemanda()">
                            <mat-icon>update</mat-icon> Alterar taxa (%) em demanda
                        </button>
                    </div>

                    <div class="col-sm text-right">
                        <button mat-flat-button color="warn" (click)="exportar()">
                            <mat-icon>print</mat-icon> Exportar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>